import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import moment from 'moment';
import Button from '@dbk/ui-buttons';
import { H1 } from '@dbk/ui-text';
import Grid, { Cell, SortableColumnIcon } from '@dbk/ui-grid';
// import Pagination from '../../components/common/pagination';

import Pagination from '@dbk/ui-pagination';
import InverseProvider from '@dbk/ui-inverse';

import { PAGE, DOC_STATUS_MAPPING, DATE_FORMATS, DOC_STATUS_VALIDATIONS } from '../../constants';

import Responsive from '../../components/common/responsive-dimension-values';

// import AppHeaderAdmin from '../../components/app/app-header/app-header-admin';

import Guid from '../../utils/guid';

import getOr from 'lodash/fp/getOr';
import sortBy from 'lodash/sortBy';
import reverse from 'lodash/reverse';
import find from 'lodash/find';

import BlurModal from '../../components/common/blur-modal';
import DocUpload from './doc-upload';
import FilterModal from './filter-modal';
import { LoadingCircle } from '../../components/common/loading';
import { DownloadIcon, UploadIcon } from '@dbk/ui-icons';
import { FilterIcon } from '../../components/common/icons';
import filter from '@dbk/ui-icons/src/filter';

import { excelDownload, jsonToXmlDocuCenter as jsonToXml } from './../../utils/excel-download';
import config from '../../data/get-settings';
import { PALETTE } from '../../constants'



const SORTING_ORDER = [
  { intValue: 1, stringValue: 'ASC' },
  { intValue: -1, stringValue: 'DESC' },
  { intValue: 0, stringValue: 'NA' }
];

const DOC_LIST_ADMIN_COLUMNS = [
  { columnValue: 'document_name', columnLabel: 'app.docsigncenter.uploadDoc.documentName.label' },
  { columnValue: 'template_name', columnLabel: 'app.docsigncenter.uploadDoc.documentType.label' },
  { columnValue: 'order_id', columnLabel: 'app.docsigncenter.uploadDoc.orderId.label' },
  { columnValue: 'start_date', columnLabel: 'app.docsigncenter.uploadDate' },
  { columnValue: 'client_sign_date', columnLabel: 'app.docsigncenter.signedDate' },
  { columnValue: 'name', columnLabel: 'app.docsigncenter.uploadDoc.userName.label' },
  { columnValue: 'pf_id', columnLabel: 'app.docsigncenter.uploadDoc.portfolioId.label' },
  { columnValue: 'status_for_rm', columnLabel: 'app.docsigncenter.status' }
];

const initialPageState = {
  sortedColumnIndex: -1,
  sortedDirection: 0,
  pageNumber: 0,
  pageOffset: 0
};

const initFilterOptions = {
  documentType: '',
  documentName: '',
  orderId: '',
  clientName: '',
  uploadDateFrom: '',
  uploadDateTo: '',
  dueDateFrom: '',
  dueDateTo: '',
  signedDateFrom: '',
  signedDateTo: '',
  portfolioId: '',
  rmName: '',
  rmTeam: '',
  status: ''
};

function getColumnByIndex(columnIndex) {
  if (columnIndex === -1) {
    return 'document_name';
  }
  return DOC_LIST_ADMIN_COLUMNS[columnIndex].columnValue;
}

function getSortingOrder(intValue) {
  return find(SORTING_ORDER, { intValue }).stringValue;
}

function renderHeaderCell({ columnIndex, messages }) {
  return messages[DOC_LIST_ADMIN_COLUMNS[columnIndex].columnLabel];
}

function renderDataCell({ columnIndex, row }) {
  const column = getColumnByIndex(columnIndex);
  if (!row || !column) return null;
  if (column === 'start_date') {
    return moment(row[column]).format(DATE_FORMATS.displayDate);
  }
  if (column === 'client_sign_date') {
    if (DOC_STATUS_VALIDATIONS.hideTargetDateTime.indexOf(row.document_status) === -1) {
      return moment(row[column]).format(DATE_FORMATS.displayDateAndTime);
    }
    return '-';

  }
  return row[column];
}

function getClassNamesForCell(columnIndex, rmStatus) {
  let cellStyles = "docListGrid__cell_content ";
  if (columnIndex === 0) cellStyles += "docListGrid__cell_content_firstRow ";
  if (columnIndex === 7) {
    if (find(DOC_STATUS_MAPPING, { status: rmStatus })) {
      const colorClass = find(DOC_STATUS_MAPPING, { status: rmStatus }).colorClass;
      cellStyles += colorClass;
    }
  }

  return cellStyles;
}

class CenterHome extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      docuploadModal: false,
      isLoading: false,
      totalRecords: 0,
      totalPages: 1,
      inputState: 1,
      uploadConfirmationModal: false,
      filterModal: false,
      selectedCounter: 0
    };

    this.openDocumentUploadModal = this.openDocumentUploadModal.bind(this);
    this.closeDocumentUploadModal = this.closeDocumentUploadModal.bind(this);
    this.prepareGridContents = this.prepareGridContents.bind(this);
    this.requestDocumentList = this.requestDocumentList.bind(this);
    this.setPageOffset = this.setPageOffset.bind(this);
    this.handleJumpInputChange = this.handleJumpInputChange.bind(this);
    this.handlePage = this.handlePage.bind(this);
    this.onClickDownload = this.onClickDownload.bind(this);
    this.showConfirmationModal = this.showConfirmationModal.bind(this);
    this.pressedCancel = this.pressedCancel.bind(this);
    this.handleExcelExport = this.handleExcelExport.bind(this);
    this.openFilterModal = this.openFilterModal.bind(this);
    this.closeFilterModal = this.closeFilterModal.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
  }

  componentWillMount() {
    // this.props.getUserPortfolioRelations();
    this.requestDocumentList();
  }

  componentWillUnmount() {
  }

  componentWillUpdate() {
    if (this.grid) this.grid.forceUpdateGrid();
  }

  componentDidUpdate(prevProps) {
    const { docsigncenter: { documentListForAdmin, shouldRequestDocList, documentListForAdminAll } } = this.props;
    if (documentListForAdmin === "empty") {
      this.setState({
        isLoading: false
      });
    }
    if (documentListForAdminAll === "empty") {
      //TODO handle error condition for excel download
    }

    if (prevProps.docsigncenter.documentListForAdmin !== documentListForAdmin && documentListForAdmin !== undefined) {
      if (documentListForAdmin.documentListResponse) {
        this.prepareGridContents(documentListForAdmin);
      }
    }
    if (prevProps.docsigncenter.shouldRequestDocList !== shouldRequestDocList && shouldRequestDocList !== undefined) {
      if (shouldRequestDocList) {
        this.requestDocumentList();
      }
    }
    if (prevProps.docsigncenter.documentListForAdminAll !== documentListForAdminAll && documentListForAdminAll) {
      this.handleExcelExport(documentListForAdminAll);
    }
  }


  showConfirmationModal = () => {
    this.setState({ uploadConfirmationModal: true })
  }

  pressedCancel = () => {
    this.setState({
      uploadConfirmationModal: false
    });
  }

  requestDocumentList(params) {
    const { docsigncenter: { pageNumber, sortColumnIndex, sortDirection, pageOffset, excelExportFlag, filterOptions } } = this.props;

    this.setState({
      isLoading: true
    });
    if (pageNumber === undefined || sortColumnIndex === undefined || sortDirection === undefined || pageOffset === undefined || filterOptions === undefined) {
      this.props.setPageParams({
        pageNumber: initialPageState.pageNumber,
        pageOffset: initialPageState.pageOffset,
        firstTime: true,
      });
      this.props.setSortParams({
        sortColumnIndex: initialPageState.sortedColumnIndex,
        sortDirection: initialPageState.sortedDirection,
        totalPages: this.state.totalPages,
        firstTime: true,
      });

      this.props.onSetFilterOptions(initFilterOptions, true);

      this.props.getDocumentListForAdmin(
        initialPageState.pageNumber,
        PAGE.pageSize,
        getColumnByIndex(initialPageState.sortedColumnIndex),
        getSortingOrder(initialPageState.sortedDirection),
        excelExportFlag,
        initFilterOptions

      );

    } else {
      this.props.getDocumentListForAdmin(
        pageNumber,
        PAGE.pageSize,
        getColumnByIndex(sortColumnIndex),
        getSortingOrder(sortDirection),
        excelExportFlag,
        filterOptions
      );
    }

    this.props.updateShouldRequestDocList(false);
    this.props.updateExcelExportFlag(false);
  }

  prepareGridContents(documentListForAdmin) {
    this.setState({
      isLoading: false,
      totalRecords: documentListForAdmin.totalNumberOfRecords,
      totalPages: documentListForAdmin.totalNumberOfPages
    });
  }


  handleExcelExport(documentListForAdminAll) {
    this.setState({
      isLoading: false,
    });
    const {
      i18n: { messages },
    } = this.props;
    var requiredDocumentListResponse = [];
    const arrData = [
      [messages['app.docsigncenter.uploadDoc.documentType.label'],
      messages['app.docsigncenter.uploadDoc.documentName.label'],
      messages['app.docsigncenter.uploadDoc.orderId.label'],
      messages['app.docsigncenter.uploadDoc.userName.label'],
      messages['app.docsigncenter.uploadDate'],
      messages['app.docsigncenter.targetDate'],
      messages['app.docsigncenter.excel.signedDate'],
      messages['app.docsigncenter.uploadDoc.portfolioId.label'],
      messages['app.docsigncenter.uploadDoc.rm.name'],
      messages['app.docsigncenter.uploadDoc.rm.team'],
      messages['app.docsigncenter.status'],
      messages['app.docsigncenter.uploadDoc.rm.message'],
      messages['app.docsigncenter.client.rejection.reason']
      ],
      requiredDocumentListResponse
    ];
    const docmap = config.defaultEnvironment === 'static' ? documentListForAdminAll.documentListResponse : documentListForAdminAll
    docmap.map((item, index) => {
      const requiredFields = {
        template_name: item.template_name,
        document_name: item.document_name,
        order_id: item.order_id,
        name: item.name,
        start_date: item.start_date,
        due_date: item.target_date,
        signed_date: item.client_sign_date,
        pfid: item.pf_id,
        rmName: item.rmName,
        rmTeam: item.rmTeam,
        status: item.status_for_rm,
        rmMessage: item.rm_message,
        rejectMessage: item.rejectMessage

      }
      requiredDocumentListResponse.push(requiredFields);

    })


    excelDownload(
      jsonToXml(arrData),
      'eSignature',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );
  }



  openDocumentUploadModal() {
    this.props.getDocumentTypeList();
    this.props.getEligiblePfList();
    this.setState({ docuploadModal: true });
  }
  closeDocumentUploadModal() {
    this.props.resetEligibleClientList();
    this.setState({ docuploadModal: false });
  }

  openFilterModal() {
    this.props.getDocumentTypeList();
    this.props.getEligiblePfList();
    this.props.getRmTeamList();
    this.setState({ filterModal: true });
  }

  updateCounter = filteroptions => this.setState({ selectedCounter: filteroptions.filter(e => e).length })

  refactorFilterOptions = filteroptions => ({
    ...filteroptions,
    uploadDateFrom: null,
    dueDateFrom: null,
    signedDateFrom: null
  })

  applyFilter(filterOptions, firstTime) {
    this.props.onSetFilterOptions(filterOptions, firstTime);
    this.updateCounter(Object.values(this.refactorFilterOptions(filterOptions)));
    this.closeFilterModal();
  }

  closeFilterModal = () => {
    this.setState({ filterModal: false });
  }

  setRef = ref => { this.grid = ref; }
  rowHeight = ({ index }) => (index === 0 ? 65 : 85);

  columnWidth({ index }) {

    // const maxGrid = 1710; //1550; 
    // const minGrid = 1130;
    // const availableGrid = Responsive.windowWidth * 0.9;

    // const maxWidths = [190, 360, 170, 190, 250, 190, 190, 190]; //[170, 330, 150, 170, 220, 170, 170, 170];
    // const minWidths = [130, 220, 110, 130, 130, 130, 130, 130]

    // let columnWidth = minWidths[index];

    // if (availableGrid >= maxGrid) {
    //   columnWidth = maxWidths[index];
    // } else if (availableGrid >= minGrid) {
    //   columnWidth = (availableGrid / maxGrid) * maxWidths[index];
    // }

    const widthsInPercentage = ['11%', '20%', '10%', '11%', '14%', '11%', '11%', '11%'];
    const columnWidth = widthsInPercentage[index];

    return columnWidth;
  }


  async setPageOffset(newOffset) {
    const pageNumber = newOffset === 0 ? 0 : newOffset / PAGE.pageSize;
    await this.props.setPageParams({ pageNumber, pageOffset: newOffset, firstTime: false });

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  handleJumpInputChange(event) {
    if (event.target.value.match(/^\d*$/gi)) {
      this.setState({
        inputState: event.target.value,
      });
    }
  };

  async handlePage(page) {
    if (page >= 1 && page <= this.state.totalPages) {
      this.setState({
        // activePageId: page,
        inputState: page,
      });

      const pageNumber = page - 1;
      const newOffset = pageNumber * PAGE.pageSize;
      await this.props.setPageParams({ pageNumber, pageOffset: newOffset, firstTime: false });
    }

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  async toggleSorted(columnIndex) {
    const { docsigncenter: { sortColumnIndex, sortDirection } } = this.props;
    const order = [1, -1, 0];
    const sortedColumnIndex = columnIndex;
    let sortedDirection = order[0];

    if (sortedColumnIndex === sortColumnIndex) {
      let next = order.indexOf(sortDirection) + 1;
      if (next >= order.length) next = 0;
      sortedDirection = order[next];
    }

    await this.props.setSortParams({
      sortColumnIndex: sortedColumnIndex,
      sortDirection: sortedDirection,
      totalPages: this.state.totalPages,
      firstTime: false,
    });


    if (this.state.totalPages === 1) {
      var sortedRowsFromProps = this.props.docsigncenter.documentListForAdmin;
      const sortColumn = getColumnByIndex(sortedColumnIndex);
      let sortedRows = sortedRowsFromProps.documentListResponse;

      if (sortedDirection === 1) {
        sortedRows = sortBy(sortedRowsFromProps.documentListResponse, [sortColumn])
      } else if (sortedDirection === -1) {
        sortedRows = sortBy(sortedRowsFromProps.documentListResponse, [sortColumn])
        sortedRows = reverse(sortedRows);
      }

      sortedRowsFromProps.documentListResponse = sortedRows;
      sortedRowsFromProps.changeRand = Guid();
      this.props.localUpdateDocumentListForAdmin(sortedRowsFromProps);
    }
  }

  renderCell = ({ rowIndex, columnIndex, gridRowIndex, gridColumnIndex }) => {
    const {
      i18n: { messages },
      docsigncenter: { sortColumnIndex, sortDirection }
    } = this.props;
    const sorted =
      columnIndex === sortColumnIndex
        ? sortDirection
        : 0;

    if (rowIndex === 0) {
      return (
        <Cell
          {...{ gridRowIndex, gridColumnIndex }}
          header
          sortable
          sorted={sorted}
          className="docListGrid__cell_header"
          onClick={() => this.toggleSorted(columnIndex)}
        >
          {renderHeaderCell({ columnIndex, messages })}
          <SortableColumnIcon sorted={sorted} />
        </Cell>
      );
    }

    var sortedRows = this.props.docsigncenter.documentListForAdmin.documentListResponse;
    return (
      <Cell
        {...{ gridRowIndex, gridColumnIndex }}
        className={getClassNamesForCell(columnIndex, sortedRows[rowIndex - 1].document_status)}
        onClick={() => this.props.changePage('/docsigncenter/docdetails/' + sortedRows[rowIndex - 1].dwo_doc_sid)}>
        {renderDataCell({ columnIndex, row: sortedRows[rowIndex - 1] })}
      </Cell>
    );

  };



  onClickDownload() {
    this.props.updateExcelExportFlag(true);
  };


  render() {
    const {
      i18n: { messages },
      docsigncenter: {
        documentListForAdmin,
        // pageOffset,
        pageNumber
      } } = this.props;

    return (
      <div testID="docSignCenter-dashboard" className="docsigncenter">
        {/* {this.props.auth.isAdminUser && <AppHeaderAdmin />} */}
        <div testID="docSignCenter-dashboard-header" className="row large-10 medium-10 large-10">
          <div className="margin-bottom-30">
            <div className="docCenterHeader" testID="docSignCenter-dashboard-header-title"> {messages['app.docsigncenter']}</div>
          </div>
          <div className="text-end">
            <div className="margin-top-10">
              <div style={{ float: 'right' }}>
                <div className="doc-button-download">
                  <Button
                    testID="btn_centerHome_download_test"
                    secondary
                    // loading={this.state.isLoading}
                    onClick={this.onClickDownload}
                  >
                    <DownloadIcon />

                    {messages['app.docsigncenter.download.button']}
                  </Button>
                </div>





                {this.state.selectedCounter >= 1 ?
                  <div className='fortest doc-button-filter' style={{ color: PALETTE.primaryActive }}>
                    <Button
                      testID="btn_centerHome_filterModal_test"
                      secondary
                      onClick={() => this.openFilterModal()}

                    >
                      <FilterIcon color='#ff0' />
                      {messages['app.docsigncenter.filter'] + '  (' + this.state.selectedCounter + ')'}
                    </Button> </div> :
                  <div className="doc-button-filter_selected" >
                    <Button
                      testID="btn_centerHome_filterModal_test"
                      secondary
                      onClick={() => this.openFilterModal()}
                    >
                      <FilterIcon />
                      {messages['app.docsigncenter.filter']}
                    </Button>
                  </div>
                }

                <div className="upload-doc-button" >
                  <Button
                    testID="btn_centerHome_uploadModal_test"
                    onClick={() => this.openDocumentUploadModal()}
                  >
                    <UploadIcon />
                    {messages["app.docsigncenter.uploadDoc"]}
                  </Button>

                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="margin-top-20">
          {this.state.isLoading && <LoadingCircle />}
          {!this.state.isLoading && documentListForAdmin === "empty" && <H1> {messages['app.docsigncenter.noDocumentsError']}</H1>}

          {!this.state.isLoading && documentListForAdmin && documentListForAdmin.documentListResponse &&
            <div className="docListGrid docListGrid--sortable">
              <Grid
                ref={this.setRef}
                classNameTop="docListGrid__topGrid"
                classNameMain="docListGrid__mainGrid"
                rowCount={documentListForAdmin.documentListResponse.length + 1}
                stickyTopRowCount={1}
                rowHeight={this.rowHeight}
                columnCount={8}
                columnWidth={this.columnWidth}
                renderCell={this.renderCell}
              />

              <InverseProvider inverse className="paginationWrapper">
                <Pagination
                  className="paginationComponent"
                  pageLabel={messages['app.docsigncenter.pagination.page']}
                  firstLabel={messages['app.docsigncenter.pagination.firstLabel']}
                  lastLabel={messages['app.docsigncenter.pagination.lastLabel']}
                  previousLabel={messages['app.docsigncenter.pagination.previousLabel']}
                  nextLabel={messages['app.docsigncenter.pagination.nextLabel']}
                  jumpToLabel={messages['app.docsigncenter.pagination.jumpToLabel']}
                  onPage={this.handlePage}
                  activePageIndex={pageNumber + 1}
                  jumpInputProps={{
                    value: this.state.inputState,
                    onChange: this.handleJumpInputChange,
                  }}
                  numPages={this.state.totalPages}
                />
              </InverseProvider>
              {/* <Pagination
                pageOffset={pageOffset}
                pageSize={PAGE.pageSize}
                totalRecords={this.state.totalRecords}
                setPageOffset={this.setPageOffset}
                onPageChange={() => { }} // Empty function so Paginatin doesnot through console error
                style={{ marginVertical: 20, justifyContent: 'flex-end' }} /> */}
            </div>
          }

        </div>

        {this.state.docuploadModal ?
          <BlurModal
            disableOutsideClick
            hasHeader
            title={messages["app.docsigncenter.uploadDoc"]}
            visible={this.state.docuploadModal}
            onDone={this.closeDocumentUploadModal}
            doneLabel={messages["app.common.closeText"]}
            doneVisible
            disableDone={false}
            size={'large'}
          >
            <DocUpload
              onCloseModal={this.closeDocumentUploadModal}
              confirmationModal={this.showConfirmationModal} />
          </BlurModal> : null}

        {this.state.uploadConfirmationModal ?
          <BlurModal
            hasHeader
            title={messages['app.docsigncenter.docdetails.blurmodal.upload.confirm']}
            visible={this.state.uploadConfirmationModal}
            doneVisible
            doneLabel={messages["app.common.closeText"]}
            onDone={this.pressedCancel}
          >
            <div>
              <div>{messages['app.docsigncenter.docdetails.blurmodal.document.sent']}</div>
              <div className="row">
                <div className="btn timeout-modal">

                  <Button
                    testID="docDetails-acknowledgement-ok"
                    onClick={() => this.pressedCancel()}>
                    {messages["app.rmcallback.okMsg"]}
                  </Button>
                </div>
              </div>
            </div>
          </BlurModal> : null
        }


        {this.state.filterModal ?
          <BlurModal
            disableOutsideClick
            hasHeader
            title={`Filters(${this.state.selectedCounter})`}
            visible={this.state.filterModal}
            onDone={this.closeFilterModal}
            doneLabel={messages["app.common.closeText"]}
            doneVisible
            disableDone={false}
            size={'large'}
          >

            <FilterModal
              onCloseModal={this.closeFilterModal}
              onApplyFilter={this.applyFilter}
            />

          </BlurModal> : null}



      </div>
    );

  }
}

export default createContainer({
  $queries: {
    auth: {
      isAdminUser: true,
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    getDocumentTypeList: { $call: 'docsigncenter.getDocumentTypeList' },
    getEligiblePfList: { $call: 'docsigncenter.getEligiblePfList' },
    getDocumentListForAdmin: { $call: 'docsigncenter.getDocumentListForAdmin' },
    viewDocumentForAdmin: { $call: 'docsigncenter.viewDocumentForAdmin' },
    localUpdateDocumentListForAdmin: { $call: 'docsigncenter.localUpdateDocumentListForAdmin' },
    setPageParams: { $call: 'docsigncenter.setPageParams' },
    setSortParams: { $call: 'docsigncenter.setSortParams' },
    updateShouldRequestDocList: { $call: 'docsigncenter.updateShouldRequestDocList' },
    resetEligibleClientList: { $call: 'docsigncenter.resetEligibleClientList' },
    updateExcelExportFlag: { $call: 'docsigncenter.updateExcelExportFlag' },
    getRmTeamList: { $call: 'docsigncenter.getRmTeamList' },
    onSetFilterOptions: { $call: 'docsigncenter.setFilterOptions' },
    docsigncenter: {
      documentListForAdmin: true,
      pageNumber: true,
      pageOffset: true,
      sortColumnIndex: true,
      sortDirection: true,
      shouldRequestDocList: true,
      excelExportFlag: true,
      documentListForAdminAll: true,
      filterOptions: true
    }
  }
})(CenterHome);

export { CenterHome };